export const checkIsFieldEmpty = (arr, successCallback) => {
  const isFieldEmpty = arr.some((item) => !item);
  if (typeof successCallback === 'function') return successCallback(!!isFieldEmpty);
  return null;
};
